import React from 'react';

const Personvern: React.FC = () => {
  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem' }}>
      <h1>Personvernerklæring</h1>
      
      <p style={{ marginTop: '1rem', marginBottom: '2rem' }}>
        Denne personvernerklæringen beskriver hvordan Sykkelfest samler inn, bruker og beskytter
        dine personopplysninger i samsvar med personopplysningsloven og GDPR.
      </p>

      <section style={{ marginTop: '2rem' }}>
        <h2>1. Behandlingsansvarlig</h2>
        <p>
          Behandlingsansvarlig for personopplysninger i Sykkelfest er:
        </p>
        <p style={{ marginLeft: '1rem' }}>
          <strong>Simon Skotheimsvik</strong><br />
          E-post: <a href="mailto:kontakt@sykkelfest.no" style={{ color: 'var(--primary-color)' }}>kontakt@sykkelfest.no</a>
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>2. Hvilke personopplysninger samler vi inn</h2>
        <p>Vi samler inn følgende opplysninger om deg:</p>
        
        <h3 style={{ marginTop: '1.5rem', fontSize: '1.1rem' }}>Når du oppretter en konto:</h3>
        <ul>
          <li>Navn (fornavn og etternavn)</li>
          <li>E-postadresse</li>
          <li>Telefonnummer</li>
          <li>Adresse (gateadresse, postnummer, poststed)</li>
          <li>Passord (lagret kryptert)</li>
        </ul>

        <h3 style={{ marginTop: '1.5rem', fontSize: '1.1rem' }}>Når du deltar på arrangement:</h3>
        <ul>
          <li>Påmeldingsinformasjon (arrangement, partnernavn)</li>
          <li>Matpreferanser og allergier</li>
          <li>Vertsinformasjon (om du er vert for en rett)</li>
          <li>Genererte ruter og stopp du besøker</li>
          <li>Interaksjoner med andre deltakere</li>
        </ul>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>3. Hvorfor samler vi inn personopplysninger</h2>
        <p>Vi behandler personopplysninger for følgende formål:</p>
        <ul>
          <li><strong>Gjennomføring av arrangement:</strong> For å kunne pare deltakere, generere ruter, og koordinere arrangement</li>
          <li><strong>Kommunikasjon:</strong> For å sende viktig informasjon om arrangement, påmeldinger, og endringer</li>
          <li><strong>Kontakt mellom deltakere:</strong> For at deltakere som skal spise sammen kan ta kontakt og koordinere</li>
          <li><strong>Sikkerhet:</strong> For å beskytte mot misbruk og uautorisert tilgang</li>
          <li><strong>Oppfyllelse av kontrakt:</strong> For å levere tjenesten du har registrert deg for</li>
        </ul>
        
        <p style={{ marginTop: '1rem' }}>
          <strong>Rettslig grunnlag:</strong> Behandlingen er nødvendig for å oppfylle avtalen med deg
          (GDPR art. 6 nr. 1 bokstav b), samt ditt samtykke til deling av informasjon med andre
          deltakere (GDPR art. 6 nr. 1 bokstav a).
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>4. Hvor lenge lagrer vi opplysningene</h2>
        <p>Vi lagrer personopplysninger så lenge det er nødvendig for formålet:</p>
        <ul>
          <li><strong>Brukerkonto:</strong> Så lenge kontoen er aktiv. Du kan når som helst slette kontoen din.</li>
          <li><strong>Arrangementdata:</strong> I 1 måned etter arrangementet er gjennomført, deretter anonymiseres data for statistikk</li>
        </ul>
        <p style={{ marginTop: '1rem' }}>
          Etter disse periodene slettes eller anonymiseres dataene, med mindre vi er forpliktet til
          å oppbevare dem lenger av juridiske årsaker.
        </p>
        <p style={{ marginTop: '1rem' }}>
          <strong>E-postkommunikasjon:</strong> Systemet lagrer ikke e-postinnhold. E-poster sendes via
          Azure Communication Services, som kan ha egne logger i henhold til deres retningslinjer.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>5. Hvem har tilgang til opplysningene</h2>
        <p>Dine personopplysninger deles med:</p>
        
        <h3 style={{ marginTop: '1.5rem', fontSize: '1.1rem' }}>Andre deltakere på arrangement:</h3>
        <ul>
          <li>Deltakere du spiser sammen med får tilgang til navn i en periode etter måltidet</li>
          <li>Når du er vert for ett måltid, får måltidets deltakerne også din adresse</li>
          <li>Dette er nødvendig for gjennomføringen av arrangementet</li>
        </ul>

        <h3 style={{ marginTop: '1.5rem', fontSize: '1.1rem' }}>Arrangør:</h3>
        <ul>
          <li>Arrangør av et arrangement ser alle deltakeres informasjon for å kunne koordinere arrangementet</li>
        </ul>

        <h3 style={{ marginTop: '1.5rem', fontSize: '1.1rem' }}>Tekniske tjenesteleverandører:</h3>
        <ul>
          <li><strong>Microsoft Azure:</strong> Hosting av database og applikasjon (serverplassering: EU)</li>
          <li><strong>Azure Communication Services:</strong> Utsending av ukryptert e-post</li>
          <li><strong>Azure Maps:</strong> Beregning av ruter og avstander</li>
          <li><strong>Google reCAPTCHA:</strong> Beskyttelse mot spam (se reCAPTCHA-vilkår)</li>
        </ul>

        <p style={{ marginTop: '1rem' }}>
          Vi deler <strong>ikke</strong> personopplysninger med tredjeparter for markedsføring eller andre
          formål som ikke er nødvendige for tjenesten.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>6. Dine rettigheter</h2>
        <p>Du har følgende rettigheter etter GDPR:</p>
        <ul>
          <li><strong>Rett til innsyn:</strong> Du kan be om en kopi av alle opplysninger vi har om deg</li>
          <li><strong>Rett til retting:</strong> Du kan oppdatere og rette feil i dine opplysninger via din profil</li>
          <li><strong>Rett til sletting:</strong> Du kan når som helst slette kontoen din og alle tilhørende data</li>
          <li><strong>Rett til begrensning:</strong> Du kan be om at behandlingen begrenses i visse situasjoner</li>
          <li><strong>Rett til dataportabilitet:</strong> Du kan be om å få dine data i et strukturert format</li>
          <li><strong>Rett til å trekke tilbake samtykke:</strong> Der behandling er basert på samtykke, kan du trekke dette tilbake</li>
          <li><strong>Rett til å klage:</strong> Du kan klage til Datatilsynet hvis du mener vi behandler dine opplysninger feil</li>
        </ul>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>7. Sikkerhet</h2>
        <p>
          Vi bruker tekniske og organisatoriske sikkerhetstiltak for å beskytte dine personopplysninger:
        </p>
        <ul>
          <li>Kryptert lagring av passord (bcrypt)</li>
          <li>HTTPS/TLS-kryptering for all kommunikasjon</li>
          <li>Tilgangskontroll og autentisering</li>
          <li>Regelmessige sikkerhetsoppdateringer</li>
          <li>Logging og overvåking av systemet</li>
        </ul>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>8. Kontaktinformasjon</h2>
        <p>
          For spørsmål om personvern, innsyn, sletting eller andre henvendelser, ta kontakt:
        </p>
        <p style={{ marginLeft: '1rem', marginTop: '1rem' }}>
          <strong>E-post:</strong> <a href="mailto:kontakt@sykkelfest.no" style={{ color: 'var(--primary-color)' }}>kontakt@sykkelfest.no</a><br />
          <strong>Kontaktskjema:</strong> <a href="/kontakt" style={{ color: 'var(--primary-color)' }}>sykkelfest.no/kontakt</a>
        </p>
        <p style={{ marginTop: '1rem' }}>
          Du kan også klage til <strong>Datatilsynet</strong> dersom du mener vi behandler personopplysningene
          dine i strid med personvernregelverket:<br />
          <a 
            href="https://www.datatilsynet.no" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: 'var(--primary-color)' }}
          >
            www.datatilsynet.no
          </a>
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>9. Endringer i personvernerklæringen</h2>
        <p>
          Vi kan oppdatere denne personvernerklæringen fra tid til annen. Vesentlige endringer
          vil bli varslet via e-post eller ved innlogging. Vi oppfordrer deg til å gjennomgå
          denne erklæringen jevnlig.
        </p>
      </section>

      <p style={{ marginTop: '3rem', color: '#6b7280', fontSize: '0.9rem' }}>
        Sist oppdatert: {new Date().toLocaleDateString('nb-NO')}
      </p>
    </div>
  );
};

export default Personvern;
